import { bl_fi_entity_purchase_credit_limit_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PurchaseCreditLimitContainerModel extends BaseContainerModel{
    bl_fi_entity_purchase_credit_limit: bl_fi_entity_purchase_credit_limit_RowClass=new bl_fi_entity_purchase_credit_limit_RowClass();
}